import * as Yup from "yup";


export const ContinuingEducationValidation = Yup.object({
    courseName: Yup.string()
        .required("Course name is required")
        .max(255, "Course name must be at most 255 characters"),

    courseLink: Yup.string()
        .nullable()
        .max(500, "Course link must be at most 500 characters"),

    courseHours: Yup.number()
        .typeError("Course hours must be a number")
        .required("Course hours is required")
        .min(0, "Course hours must be at least 0").max(999, "Course hours must be at most 999"),

    courseStartDate: Yup.date()
        .typeError("Must be a valid date")
        .required("Course start date is required"),

    courseEndDate: Yup.date()
        .typeError("Must be a valid date")
        .required("Course end date is required")
        .min(Yup.ref('courseStartDate'), "Course end date cannot be before the start date")
        .test('max-one-year', "Course end date must be within 1 year of the start date", function (courseEndDate) {
            const { courseStartDate } = this.parent
            if (!courseEndDate || !courseStartDate) return true
            const maxEndDate = new Date(courseStartDate)
            maxEndDate.setFullYear(maxEndDate.getFullYear() + 1)
            return courseEndDate <= maxEndDate
        }),

    courseDescription: Yup.string()
        .required("Course description is required")
        .max(2000, "Course description must be at most 2000 characters"),

    cost: Yup.number()
        .typeError("Cost must be a number")
        .required("Cost is required")
        .min(0, "Cost must be at least 0").max(999999, "Cost must be at most 999,999"),

    environmentId: Yup.string()
        .required("Environment is required"),

    typeId: Yup.string()
        .required("Type is required"),

    topicId: Yup.string()
        .required("Topic is required"),
});
